import React from "react";
import { Link, useNavigate } from "react-router-dom";
// import BajajLogo from "../asset/images/Bajaj logo.png";
import ErrorImg from "../asset/images/404image.svg";
import { Constants } from "./Constants";


function Blank() {
  // const navigate = useNavigate();

  function myFunction() {
    window.history.back();
  }


  return (
    <div className="main-screen error-blank">
      <div className="page-not-found">
        <div>
          <img src={ErrorImg} alt="" className="error_img" />
        </div>
        <div className="page-not-found-content">
          <h4 className="title">{Constants.Page_Not_Found}</h4>
          <p className="desc">{Constants.Requested_page_notFound}</p>
          {/* <div> */}
          <Link >
            <button
              className="send-message"
              onClick={myFunction}
            >
              {Constants.Go_Back}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
export default Blank;
